import React from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../pages/legal/Legal.css";

const versionApp = require("../../package.json");

export default function LegalFooter() {
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <div className="site-legal-footer">
      <div className="legal-footer-logo">
        <img
          src={process.env.PUBLIC_URL + "/assets/uploads/logo/logo.png"}
          alt="PPShope"
          loading="lazy"
        />
      </div>
      <p className="legal-footer-desc">{t("FoottetDetail")}</p>

      <div className="legal-footer-links">
        <a href="#" onClick={(e) => { e.preventDefault(); history.push("/about"); }}>
          {t("footerAbout")}
        </a>
        <a href="#" onClick={(e) => { e.preventDefault(); history.push("/contact"); }}>
          {t("footerContact")}
        </a>
        <a href="#" onClick={(e) => { e.preventDefault(); history.push("/privacy-policy"); }}>
          {t("footerPrivacy")}
        </a>
        <a href="#" onClick={(e) => { e.preventDefault(); history.push("/terms-of-service"); }}>
          {t("footerTerms")}
        </a>
        <a href="#" onClick={(e) => { e.preventDefault(); history.push("/refund-policy"); }}>
          {t("footerRefund")}
        </a>
      </div>

      <div className="legal-footer-divider" />

      <div className="legal-footer-contact">
        <span>📧 paoxayyasan@gmail.com</span>
        <span>📱 +856 2098888841</span>
        <span>
          🔗{" "}
          <a
            href="https://www.facebook.com/ppshope/"
            target="_blank"
            rel="noreferrer"
            style={{ color: "rgba(255,255,255,0.4)", textDecoration: "none" }}
          >
            Facebook
          </a>
        </span>
      </div>

      <p className="legal-footer-copyright">
        © {new Date().getFullYear()} PPShope. All rights reserved. v{versionApp?.version}
      </p>
    </div>
  );
}
